export const caseInsensitiveIncludes = (
  arr: string[] | undefined,
  val: string
) => {
  if (!arr) return false;
  return arr.map((v) => v.toLowerCase()).includes(val.toLowerCase());
};
